import { PdaAccessToken } from "src/app/pda/utils/Service/pda-auth.service";

export class PdaListaPagamentiRequest{
  token!: PdaAccessToken;
  codiceUfficio!: string;
  stato!: string;
  richiestaDataDa!: string;
  richiestaDataA!: string;
  ricevutaDataDa!: string;
};
